<template>
  <div :id="brainsDataListId" class="brains-data-list-container">
    <div class="brains-data-list--title" v-html="title" />

    <div class="brains-data-list--content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrainsDataList',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      randomNum: 0
    }
  },
  computed: {
    brainsDataListId() {
      return 'brains-data-list-' + this.randomNum
    },
    overflow() {
      if (this.clientWidth < this.scrollWidth) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.generateRandomNum()
  },
  methods: {
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.brains-data-list-container {
  width: 100%;

  .brains-data-list--title {
    font-size: 15px;
    font-family: "Montserrat-SemiBold",sans-serif;
    padding-bottom: 8px;
    border-bottom: 2px solid $primary-brains;
    padding-left: 5px;
    margin-bottom: 5px;
  }
}
</style>
